import { fetchEventSource, FetchEventSourceInit } from '@microsoft/fetch-event-source';

import { BASE_URL } from 'context/ApiContext';
import { useAuthContext } from 'context/AuthContext';

type EventStream = {
    url: string;
    body: unknown;
    events: Pick<FetchEventSourceInit, 'onerror' | 'onmessage' | 'onclose' | 'onopen'>;
};

type UseNewEventStream = {
    createEventStream: (params: EventStream) => Promise<void>;
};

export function useEventStream(): UseNewEventStream {
    const { token } = useAuthContext();

    const createEventStream = ({ url, body, events }: EventStream): Promise<void> =>
        fetchEventSource(`${BASE_URL}${url}`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'text/event-stream',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            ...events,
        });

    return { createEventStream };
}
